import { PipelineCountService } from './../../services/pipeline-count.service';
import { Injectable } from '@angular/core';
import { tap } from 'rxjs/operators';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { AppState } from '../reducers';
import { dailyPipelinesGet, dailyPipelinesLoad } from '../actions/account.actions';
import * as moment from 'moment';



@Injectable()
export class DailyPipelinesEffects {

    dailyPipelinesGet$ = createEffect(() => this.actions$
        .pipe(
            ofType(dailyPipelinesGet),
            tap(async action => {
                try {
                    const self = this;
                    const today = new Date();
                    const pipeLineCountDate = moment(new Date(today)).subtract(30, 'days').calendar();
                    const pipeLineCountDateFormatted = moment(pipeLineCountDate, 'MM/DD/YYYY').format('YYYY-MM-DD');
                    const response = await this.pipelineCountService.getByUTCDate(pipeLineCountDateFormatted);
                    const dates = this.pipelineCountService.getDateRangeArray
                        (new Date(pipeLineCountDate), new Date(today), 'YYYY-MM-DD');
                    const data = new Array(dates.length).fill(0);

                    response.body['data'].forEach((value) => {
                        const dateIdx = dates.indexOf(value.attributes.date);
                        data[dateIdx] = value.attributes.quantity;
                    });

                    this.store$.dispatch(dailyPipelinesLoad({
                        dailyPipelines: {
                            labels: dates,
                            data: data
                        }
                    }));
                }
                catch (error) {
                    throw error;
                }
            })
        ),
        { dispatch: false }
    );

    constructor(
        private actions$: Actions,
        private pipelineCountService: PipelineCountService,
        private store$: Store<AppState>
    ) { }

}